var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Fire",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c15538",
    d: "M21 14.1c-.3-3.6-1.9-5.8-3.4-7.8S15 2.8 15 .5c0-.2-.1-.4-.3-.4-.2-.1-.4-.1-.5 0-2.3 1.7-3.9 4.1-4.7 6.8-.3 1.6-.5 3.3-.5 5-2-.4-2.5-3.5-2.5-3.5 0-.2-.3-.4-.6-.4h-.1c-.1.1-2.6 1.4-2.8 6.5v.5c0 5 4 9 9 9s9-4 9-9v-.9zM9 19.8v-.2c0-.6.1-1.1.3-1.6.3.7.9 1.2 1.7 1.2.3 0 .5-.2.5-.5 0-.8 0-1.5.2-2.3.2-.7.5-1.4 1-1.9.2.7.6 1.3 1 1.9.7.9 1.2 2 1.3 3.1v.3c0 1.7-1.3 3.1-3 3.2-1.7-.1-3.1-1.5-3-3.2z",
    className: "color303c42 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.f166fc85788c7dfe6b9c0bca4f3142e6.svg";
export { ForwardRef as ReactComponent };